import Vehicle from "@/models/Vehicle";

export default class VehicleTransformer {
    transform (data) {
        return new Vehicle(
            data.id,
            data.fleetId,
            data.driverId,
            data.manufacturer,
            data.vrn ? data.vrn : data.registrationNumber,
            data.hexColor,
            data.model,
            data.engineSize,
            data.fuelType,
            data.type,
            data.createdOn,
            data.createdBy,
            data.trackingDeviceId,
            data.trackingHardwareId,
            data.mediaDeviceId,
            data.mediaHardwareId,
            data.driverName,
            data.fleetName,
            data.organizationName,
            data.isFavourite,
            data.firstReported,
            data.canRequestImage,
            data.canRequestVideo,
            data.canRebootTrackingDevice,
            data.canRebootMediaDevice,
            data.canFormatTrackingDevice,
            data.canFormatMediaDevice,
            data.hasHadDevice
        );
    }
}
